import { Component, Vue } from 'vue-property-decorator';
import { getResizeImage } from '@/utils/commonUtils';
import ContentType from '@/common/interfaces/enums/ContentType';
import ContentCategory from '@/common/interfaces/enums/ContentCategory';

import { FeaturedArticlesBlockViewModel } from './FeaturedArticlesModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import ArticleCardComponent from '@/components/ArticleCard/ArticleCard.vue';

const FeaturedArticlesModuleProps = Vue.extend({
  props: getComponentProps<FeaturedArticlesBlockViewModel>({
    FeaturedArticles: [
      {
        StandFirst: 'This morning we awoke to a pod of killer whales trailing our vessel…',
        ArticleLink: { Title: 'Taste of Alaska', Link: '#watch' },
        Image: {
          Url: getResizeImage('man-out-boat.jpg'),
          Alt: 'Man with boat',
        },
        Date: 'JUN 2019',
        Type: ContentType.Watch,
        Minutes: null,
        Category: ContentCategory.BehindTheExpedition,
        CategoryLink: '#',
        IsLandscape: true,
        Quote: 'test',
      },
      {
        StandFirst: 'Chef Evandro on bringing authentic cuisine to the Orion',
        ArticleLink: { Title: 'Dishes of Belize', Link: '#' },
        Image: {
          Url: getResizeImage('ancient-architecture.jpg'),
          Alt: 'Ruins',
        },
        Date: 'JUN 2019',
        Type: ContentType.Read,
        Minutes: 5,
        Category: ContentCategory.Culture,
        CategoryLink: '#',
        IsLandscape: false,
      },
    ],
    InBriefArticles: [
      {
        StandFirst: 'Sven-Olof Lindblad on 50 years of sustainable travel',
        ArticleLink: { Title: 'Opinion: leave only footprints', Link: '#' },
        Image: {
          Url: getResizeImage('flamingo.jpg'),
          Alt: 'Flamingo',
        },
        Date: 'JUN 2019',
        Type: ContentType.Read,
        Minutes: 2,
        Category: ContentCategory.WildLife,
        CategoryLink: '#',
        IsLandscape: true,
        Quote: 'test',
      },
      {
        StandFirst: 'Yogii Marion Day explains ship deck meditation',
        ArticleLink: { Title: 'Journey to inner worlds', Link: '#' },
        Image: {
          Url: getResizeImage('sea-lion.jpg'),
          Alt: 'Sea lion',
        },
        Date: 'JUN 2019',
        Type: ContentType.Read,
        Minutes: 2,
        Category: ContentCategory.BehindTheExpedition,
        CategoryLink: '#',
        IsLandscape: true,
      },
      {
        StandFirst: 'Expedition photographer Linda Burback discusses her perfect shot',
        ArticleLink: { Title: 'And then it appeared...', Link: '#' },
        Image: {
          Url: getResizeImage('kayak.jpg'),
          Alt: 'Kayak',
        },
        Date: 'JUN 2019',
        Type: ContentType.Read,
        Minutes: 2,
        Category: ContentCategory.BehindTheExpedition,
        CategoryLink: '#',
        IsLandscape: true,
      },
      {
        StandFirst: 'Expedition photographer Linda Burback discusses her perfect shot',
        ArticleLink: { Title: 'Lorem Ipsum', Link: '#' },
        Image: {
          Url: getResizeImage('seal.jpg'),
          Alt: 'Seal',
        },
        Date: 'JUN 2019',
        Type: ContentType.Read,
        Minutes: 2,
        Category: ContentCategory.WildLife,
        CategoryLink: '#',
        IsLandscape: true,
      },
    ],
  }),
});

@Component({
  components: { ArticleCardComponent },
})
export default class FeaturedArticlesModule extends FeaturedArticlesModuleProps {}
